export const OPERATION_TYPE_ADDITION = "Addition"
export const OPERATION_TYPE_SUBTRACTION = "Subtraction"
export const OPERATION_TYPE_MULTIPLICATION = "Multiplication"
export const OPERATION_TYPE_DIVISION = "Division"
export const OPERATOR_ADDITION = '+'
export const OPERATOR_SUBTRACTION = '-'
export const OPERATOR_DIVISION = '/'
export const OPERATOR_MULTIPLICATION = 'X'

export const GET_TESTS_REFRESH_INTERVAL = (30*60*1000)